import Vue from 'vue'
import { Module, ActionContext } from 'vuex'
import { RootState, TasksState } from '../store/state_models'
import { Task } from '../models'

export const tasks: Module<TasksState, RootState> = {
  namespaced: true,
  state: { tasks: {} },
  getters: {
    getById: (
        state: TasksState,
        getters: any,
        rootState: RootState,
        rootGetters: any
      ) => {
        return (taskId: string) => state.tasks[taskId]
      },
  },
  mutations: {
    addTask: (state: TasksState, task: any) => {
        Vue.set(state.tasks, task.id, Object.freeze(task))
    },
    clearAll: (state: TasksState) => {
      Vue.set(state, 'tasks', {})
    }
  },
  actions: {
    getById: {
        handler: (
        context: ActionContext<TasksState, RootState>,
        taskId: string
        ): Promise<Task> => {
        return new Promise(async (resolve, reject) => {
            try {
            let task = context.getters['getById'](taskId)
            if (task) {
                return resolve(task)
            }

            const obj = await Task.getById(taskId)
            task = { ...obj.data, id: obj.id }
            context.commit('addTask', task)
            resolve(task)
            } catch (e) {
            reject()
            }
        })
        }
    },
    logout: {
        root: true,
        handler: async (context: ActionContext<TasksState, RootState>) => {
            context.commit('clearAll')
        }
    },
    clearAll: {
        handler: async (context: ActionContext<TasksState, RootState>) => {
            context.commit('clearAll')
        }
    }
        
  }
}
